import { render, staticRenderFns } from "./EditorLists.vue?vue&type=template&id=5c34767a&"
import script from "./EditorLists.vue?vue&type=script&lang=js&"
export * from "./EditorLists.vue?vue&type=script&lang=js&"
import style0 from "./EditorLists.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports